import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

const minTimestamp = new Date('2020').getTime();

export const timeFmt = (timestamp: number | string) => {
  if (typeof timestamp === 'number' && timestamp < minTimestamp) timestamp *= 1000;
  return dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss');
};

// 相对时间显示函数
export const relativeTimeFmt = (timestamp: number | string, maxRelativeDays = 1) => {
  if (typeof timestamp === 'number' && timestamp < minTimestamp) timestamp *= 1000;

  const now = dayjs();
  const target = dayjs(timestamp);
  const diffDays = now.diff(target, 'day');

  // 超过 maxRelativeDays 天显示绝对时间
  if (diffDays >= maxRelativeDays) {
    return target.format('YYYY-MM-DD HH:mm:ss');
  }

  return target.fromNow();
};

// 获取绝对时间格式（用于tooltip）
export const absoluteTimeFmt = (timestamp: number | string) => {
  if (typeof timestamp === 'number' && timestamp < minTimestamp) timestamp *= 1000;
  return dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss');
};
